module.exports = __webpack_public_path__ + "static/media/chart.86b2ac3b.svg";